import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import {
	FaLinkedin,
	FaTwitter,
	FaFacebook,
	FaYoutube,
	FaInstagram,
	FaPinterest,
	FaTiktok
} from 'react-icons/fa'

const FollowUs = () => {
	const { site } = useStaticQuery(query)

	return (
		<nav>
			<p className="h4">Follow Us</p>

			<ul className="flex items-center gap-4 mt-4">
				{site.social?.map((social, key) => (
					<li key={key}>
						<a href={social} target="_blank" rel="noreferrer">
							<Icon className="text-3xl" social={social} />
						</a>
					</li>
				))}
			</ul>
		</nav>
	)
}

const Icon = ({ social, ...props }) => {
	return (
		social.includes('facebook') ? <FaFacebook {...props} /> :
		social.includes('twitter') ? <FaTwitter {...props} /> :
		social.includes('youtube') ? <FaYoutube {...props} /> :
		social.includes('linkedin') ? <FaLinkedin {...props} /> :
		social.includes('instagram') ? <FaInstagram {...props} /> :
		social.includes('pinterest') ? <FaPinterest {...props} /> :
		social.includes('tiktok') ? <FaTiktok {...props} /> :
		null
	)
}

export default FollowUs

const query = graphql`query FollowUs {
	site: sanitySite {
		social
	}
}`
